/* eslint-disable react/jsx-no-bind */
/* eslint-disable import/no-cycle */

import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid2";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DynamicRadioGroup from "components/DynamicRadioGroup";
import FormField from "components/FormField";
import StopsTypePicker from "components/AutoComplete/StopsTypePicker";
import TicketsPicker from "components/AsyncSelect/TicketsPicker";
import { useDispatch, useSelector } from "react-redux";
import DynamicTabs from "components/DynamicTabs";
import DataTable from "components/Tables/DataTable";
import { deleteStop, getOneItinerary } from "store/actions/itineraryActions";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import Danger from "components/Danger";
import StopsList from "pages/content/experiences/edit-experience/components/StopsList";
import VenuePicker from "components/AsyncSelect/VenuePicker";
import UploadMultiImage from "pages/content/locations/new-location/components/Sliders/UploadMultiImage";
import { useFormikContext } from "formik";

const ItineraryStops = ({
  formField,
  id,
  tabValue,
  setTabValue,
  editPage = false,
  handleSlotChange = () => {},
  handleTicketChange = () => {},
  selectedTickets = [],
  handleMediaChange = () => {},
  noTable = false,
}) => {
  const dispatch = useDispatch();
  const { values, errors, touched, setFieldValue } = useFormikContext();

  const { slot, description, type, ctaLabel, ctaUrl, venues, tickets, media, video } = formField;
  const {
    slot: slotV,
    description: descriptionV,
    type: typeV,
    ctaLabel: ctaLabelV,
    ctaUrl: ctaUrlV,
    venues: venuesV,
    media: mediaV,
    images: imageV,
    video: videoV,
  } = values;

  const [content, setContent] = useState(null);

  const itinerary = useSelector((state) => state.itineraries.itinerary);

  useEffect(() => {
    if (id) {
      dispatch(getOneItinerary(id));
    }
  }, [id]);

  const slotOptions = [
    { value: "morning", label: "Morning" },
    { value: "afternoon", label: "Afternoon" },
    { value: "evening", label: "Evening" },
    { value: "all day", label: "All day" },
  ];

  const mediaOptions = [
    { value: "none", label: "None" },
    { value: "image", label: "Image" },
    { value: "video", label: "Video" },
  ];

  const [stopTabs, setStopTabs] = useState([]);

  useEffect(() => {
    if (itinerary?.days) {
      const daysCount = itinerary.days;
      const tabs = Array.from({ length: daysCount }, (_, index) => ({
        id: index + 1,
        title: `Day ${index + 1}`,
      }));
      setStopTabs(tabs);
    }
  }, [itinerary]);

  useEffect(() => {
    if (typeV === "tickets") {
      setContent(
        <Grid size={{ xs: 12 }}>
          <TicketsPicker
            tickets={tickets}
            ticketsV={
              selectedTickets?.length > 0 && selectedTickets[0]?._id?.length > 0
                ? selectedTickets?.map((item) => ({
                    label: item?.title,
                    value: item?._id,
                  }))
                : selectedTickets
            }
            setFieldValue={setFieldValue}
            handleChange={handleTicketChange}
          />
          {errors?.tickets && <Danger validation={errors?.tickets} />}
        </Grid>
      );
    } else if (typeV === "venues") {
      setContent(
        <Grid size={{ xs: 12 }}>
          <VenuePicker
            key={venuesV?.value}
            venues={venues}
            setFieldValue={setFieldValue}
            selectedVenue={venuesV || null}
          />
          {errors?.venues && <Danger validation={errors?.venues} />}
        </Grid>
      );
    } else {
      setContent(
        <Grid container size={{ xs: 12 }} spacing={2}>
          <Grid size={{ xs: 4 }}>
            <FormField
              type={ctaLabel?.type}
              label={ctaLabel?.label || "CTA Label"}
              name={ctaLabel?.name || "ctaLabel"}
              //   value={ctaLabelV}
              placeholder={ctaLabel?.placeholder}
              error={errors.ctaLabel && touched.ctaLabel}
              success={ctaLabelV?.length > 0 && !errors.ctaLabel}
            />
          </Grid>
          <Grid size={{ xs: 8 }}>
            <FormField
              type={ctaUrl?.type}
              label={ctaUrl?.label || "CTA URL"}
              name={ctaUrl?.name || "ctaUrl"}
              //   value={ctaUrlV}
              placeholder={ctaUrl?.placeholder}
              error={errors.ctaUrl && touched.ctaUrl}
              success={ctaUrlV?.length > 0 && !errors.ctaUrl}
            />
          </Grid>
        </Grid>
      );
    }
  }, [typeV, errors, venuesV]);

  const handleSetTabValue = (event, newValue) => {
    setTabValue(newValue);

    if (newValue >= 0 && newValue < itinerary?.days) {
      //   const selectedDay = `Day ${newValue + 1}`;
      //   setTypeVal(selectedDay.toUpperCase());
    }
  };

  const handleDeleteStop = (stopId) => {
    dispatch(deleteStop(itinerary._id, stopId));
  };

  const [state, setState] = useState({
    columns: [
      { Header: "Day number", accessor: "dayNb", width: "55%" },
      { Header: "Slot", accessor: "slot" },
      { Header: "Item", accessor: "item" },
      { Header: "", accessor: "delete" },
    ],
    rows: [],
  });

  useEffect(() => {
    if (itinerary?.stops && itinerary?.stops.length > 0 && itinerary?.stops[0]?._id) {
      const transformedData = itinerary.stops?.map((stop) => {
        const dayNb = `Day ${stop.day}`;
        const slotValue = stop.slot || ""; // Rename inner slot variable
        let items = "";

        if (stop.type === "Ticket") {
          items = stop.ids?.map((ticket) => ticket.title).join(", ");
        } else if (stop.type === "Venue") {
          items = stop.ids?.map((venue) => venue.title).join(", ");
        } else {
          items = "";
        }

        return {
          dayNb,
          slot: slotValue,
          item: items,
          delete: (
            <IconButton
              aria-label="delete"
              onClick={() => handleDeleteStop(stop._id)}
              color="error"
              size="small"
            >
              <DeleteIcon />
            </IconButton>
          ),
        };
      });

      setState({ ...state, rows: transformedData });
    }
  }, [itinerary?.stops]);

  return (
    <MDBox>
      {!editPage ? (
        <MDBox lineHeight={0}>
          <MDTypography variant="h5">Stops</MDTypography>
        </MDBox>
      ) : null}
      {editPage ? (
        <StopsList
          stops={values?.stops || []}
          slotOptions={slotOptions}
          numberOfDays={values?.days}
        />
      ) : (
        <MDBox mt={1.625}>
          <Grid container spacing={3} sx={{ width: "100%", overflow: "auto" }}>
            <Grid size={{ xs: 12, md: "auto" }}>
              <MDBox>
                <DynamicTabs
                  detailTabs={stopTabs}
                  tabValue={tabValue}
                  handleSetTabValue={handleSetTabValue}
                />
              </MDBox>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid size={{ xs: 12 }}>
              <DynamicRadioGroup
                groupLabel={slot?.label || "Slot"}
                name={slot?.name || "slot"}
                value={slotV}
                options={slotOptions}
                setFieldValue={setFieldValue}
                handleChange={handleSlotChange}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <FormField
                type={description?.type}
                label={description?.label || "Description"}
                name={description?.name || "description"}
                value={descriptionV}
                placeholder={description?.placeholder}
                error={errors.description && touched.description}
                success={descriptionV?.length > 0 && !errors?.description}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <StopsTypePicker type={type} typeV={typeV} setFieldValue={setFieldValue} />
            </Grid>
            {content}
            <Grid size={{ xs: 12 }}>
              <DynamicRadioGroup
                groupLabel={media?.label || "Media"}
                name={media?.name || "media"}
                value={mediaV}
                options={mediaOptions}
                setFieldValue={setFieldValue}
                handleChange={handleMediaChange}
              />
            </Grid>
            {mediaV === "video" || mediaV === "image" ? (
              <Grid size={{ xs: 12 }}>
                {mediaV === "video" ? (
                  <FormField
                    type={video?.type}
                    label={video?.label}
                    name={video?.name}
                    value={videoV || values?.video}
                    placeholder={video.placeholder}
                    error={errors.video && touched.video}
                    success={videoV?.length > 0 && !errors.video}
                  />
                ) : (
                  <Grid size={{ sm: 12 }} sx={{ mt: 2 }}>
                    <UploadMultiImage
                      defaultImages={imageV} // Pass the defaultImages prop if needed
                      setFieldValue={setFieldValue}
                      fieldName="images" // Replace "images" with your desired field name
                    />
                  </Grid>
                )}
              </Grid>
            ) : null}
          </Grid>

          {!noTable && (
            <MDBox py={5}>
              <DataTable
                table={state}
                showTotalEntries={false}
                isSorted={false}
                entriesPerPage={false}
              />
            </MDBox>
          )}
        </MDBox>
      )}
    </MDBox>
  );
};

ItineraryStops.propTypes = {
  formField: PropTypes.instanceOf(Object).isRequired,
  id: PropTypes.string.isRequired,
  editPage: PropTypes.bool,
  handleSlotChange: PropTypes.func,
  handleTicketChange: PropTypes.func,
  selectedTickets: PropTypes.arrayOf(PropTypes.instanceOf(Object)),
  handleMediaChange: PropTypes.func,
  tabValue: PropTypes.number.isRequired,
  setTabValue: PropTypes.func.isRequired,
  noTable: PropTypes.bool,
};

export default ItineraryStops;
